import React from "react";
import { Link } from "react-router-dom";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";

import Header from "../../header/Header";
import Sidebarr from "../../sidebar/Sidebar";
import Tool from "../../sidebar/Tool";
import Footer from "../../footer/Footer";
import { vendorAdd } from "../../action";

/* 🔹 Required Label */
const RequiredLabel = ({ text }) => (
  <span>
    {text} <span style={{ color: "red" }}>*</span>
  </span>
);

/* 🔹 Reusable Input Component */
const Input = ({
  label,
  name,
  type = "text",
  register,
  errors,
  validation
}) => (
  <div className="form-group">
    <label className="col-sm-2 control-label">
      <RequiredLabel text={label} />
    </label>

    <div className="col-sm-10">
      <input
        type={type}
        className="form-control"
        {...register(name, validation)}
      />
      {errors[name] && (
        <span className="validationError">{errors[name].message}</span>
      )}
    </div>
  </div>
);

export default function AddVendor() {
  const dispatch = useDispatch();

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset
  } = useForm();

  /* 🔹 Submit Handler (Multipart) */
  const onSubmit = (data) => {
    const formData = new FormData();

    formData.append("companyCode", data.companyCode);
    formData.append("companyName", data.companyName);
    formData.append("storeCode", data.storeCode);
    formData.append("storeName", data.storeName);
    formData.append("brand", data.brand);
    formData.append("slug", data.slug);
    formData.append("storeType", data.storeType);
    formData.append("email", data.email);
    formData.append("description", data.description);

    if (data.brandImage?.[0]) {
      formData.append("brandImage", data.brandImage[0]);
    }

    dispatch(vendorAdd(formData));
    reset();
  };

  return (
    <div className="sidebar-mini skin-green-light">
      <div className="wrapper">
        <Header />
        <Sidebarr />

        <div className="content-wrapper">
          <section className="content-header">
            <h1>Add New Brand</h1>
          </section>

          <section className="content">
            <div className="box">
              <div className="box-header with-border">
                <Link to="/brand" className="btn btn-success pull-right">
                  View All Brands
                </Link>
              </div>

              <div className="box-body">
                <form
                  className="form-horizontal"
                  onSubmit={handleSubmit(onSubmit)}
                >
                  <Input
                    label="Company Code"
                    name="companyCode"
                    register={register}
                    errors={errors}
                    validation={{
                      required: "Company Code is required"
                    }}
                  />

                  <Input
                    label="Company Name"
                    name="companyName"
                    register={register}
                    errors={errors}
                    validation={{
                      required: "Company Name is required",
                      minLength: {
                        value: 3,
                        message: "Minimum 3 characters"
                      }
                    }}
                  />

                  <Input
                    label="Store Code"
                    name="storeCode"
                    register={register}
                    errors={errors}
                    validation={{
                      required: "Store Code is required"
                    }}
                  />

                  <Input
                    label="Store Name"
                    name="storeName"
                    register={register}
                    errors={errors}
                    validation={{
                      required: "Store Name is required"
                    }}
                  />

                  <Input
                    label="Brand"
                    name="brand"
                    register={register}
                    errors={errors}
                    validation={{
                      required: "Brand is required"
                    }}
                  />

                  <Input
                    label="Slug"
                    name="slug"
                    register={register}
                    errors={errors}
                    validation={{
                      required: "Slug is required",
                      pattern: {
                        value: /^[a-z0-9-]+$/,
                        message: "Only lowercase letters and hyphens allowed"
                      }
                    }}
                  />

                  <Input
                    label="Store Type"
                    name="storeType"
                    register={register}
                    errors={errors}
                    validation={{
                      required: "Store Type is required"
                    }}
                  />

                  <Input
                    label="Email"
                    name="email"
                    type="email"
                    register={register}
                    errors={errors}
                    validation={{
                      required: "Email is required",
                      pattern: {
                        value: /^\S+@\S+\.\S+$/,
                        message: "Invalid email address"
                      }
                    }}
                  />

                  {/* 🔹 Description */}
                  <div className="form-group">
                    <label className="col-sm-2 control-label">
                      <RequiredLabel text="Description" />
                    </label>
                    <div className="col-sm-10">
                      <textarea
                        className="form-control"
                        rows="4"
                        {...register("description", {
                          required: "Description is required",
                          minLength: {
                            value: 20,
                            message: "Minimum 20 characters required"
                          }
                        })}
                      />
                      {errors.description && (
                        <span className="validationError">
                          {errors.description.message}
                        </span>
                      )}
                    </div>
                  </div>

                  {/* 🔹 Brand Image */}
                  <div className="form-group">
                    <label className="col-sm-2 control-label">
                      <RequiredLabel text="Brand Image" />
                    </label>
                    <div className="col-sm-10">
                      <input
                        type="file"
                        className="form-control"
                        accept="image/*"
                        {...register("brandImage", {
                          required: "Brand image is required",
                          validate: {
                            fileType: (files) =>
                              files[0]?.type.startsWith("image/")
                                ? true
                                : "Only image files allowed",
                            fileSize: (files) =>
                              files[0]?.size <= 2 * 1024 * 1024
                                ? true
                                : "Max file size is 2MB"
                          }
                        })}
                      />
                      {errors.brandImage && (
                        <span className="validationError">
                          {errors.brandImage.message}
                        </span>
                      )}
                    </div>
                  </div>

                  {/* 🔹 Submit */}
                  <div className="form-group">
                    <div className="col-sm-offset-2 col-sm-10">
                      <button type="submit" className="btn btn-danger">
                        Submit
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </section>
        </div>

        <Footer />
        <Tool />
      </div>
    </div>
  );
}
